<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

export default {
    page: {
        title: "Especificaciones sst adquisiciones",
        meta: [{ name: "especificaciones-sst-adquisiciones", content: appConfig.description }],
    },

    components: {
        Layout,
        PageHeader,
        Style,
    },

    data() {
        return {
            title: "",
            items: [
                {
                    text: "Base de conocimiento",
                    href: "/forms/general",
                },

                {
                    text: "Procedimiento de acciones correctivas",
                    active: true,
                },
            ],
            loading: true,
            classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
            companies_id: this.$store.getters["company/getCompany"].id || null,
        };
    },

    methods: {
        /**
         * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
         * de conocimiento como desde su ítem, así que no se puede fijar el destino.
         * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
         */
        goBack() {
          if (window.history.length > 1) {
            this.$router.go(-1);
          } else {
            this.$router.push("/forms/general");
          }
        },

        /**
         * Scrollspy
         */
        scrollIntoView(evt) {
            evt.preventDefault();
            const href = evt.target.getAttribute("href");
            const el = href ? document.querySelector(href) : null;
            if (el) {
                this.$refs.content.scrollTop = el.offsetTop;
            }
        },
    },

}
</script>

<template>
    <Layout>
        <PageHeader :title="title" />

        <div class="row animated animatedFadeInUp fadeInUp">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <h4 class="header-title">Procedimiento de acciones correctivas y preventivas</h4>
                            </div>
                            <div class="col-6 text-right">
                                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                                  <i class="fas fa-arrow-left"></i>
                                </button>
                                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                            </div>
                        </div>

                        <br>

                        <b-row>
                            <b-col cols="4">
                                <b-list-group v-b-scrollspy:listgroup-ex>
                                    <b-list-group-item href="#list-item-1">1. OBJETIVO</b-list-group-item>
                                    <b-list-group-item href="#list-item-2">2. ALCANCE</b-list-group-item>
                                    <b-list-group-item href="#list-item-3">3. DEFINICIONES</b-list-group-item>
                                    <b-list-group-item href="#list-item-4">4. PROCEDIMIENTO </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col cols="8">
                                <div id="listgroup-ex" style="position: relative; overflow-y: auto; height: 300px">

                                    <h4 id="list-item-1">OBJETIVO</h4>
                                        <p>
                                            Establecer las políticas o condiciones, actividades, responsabilidades y controles para lograr elaboración,
                                            ejecución, seguimiento y cierre de las acciones preventivas y correctivas, que permitan eliminar las causas
                                            de no conformidades reales y potenciales que puedan afectar la eficiencia,
                                            eficacia y efectividad del Sistema de Gestión de Seguridad y Salud en el trabajo. 
                                        </p>

                                    <h4 id="list-item-2">ALCANCE</h4>
                                        <p>
                                            Aplica a todos los procesos del Sistema de Gestión de Seguridad y
                                            Salud en el trabajo y cubre desde la detección de una no conformidad
                                            real o potencial hasta la aplicación de las acciones necesarias para evitar su ocurrencia o que ocurra. 
                                        </p>

                                    <h4 id="list-item-3">DEFINICIONES</h4>
                                        <p>
                                            <ul>
                                                <li>
                                                    <strong>ACCIÓN CORRECTIVA:</strong> Conjunto de acciones tomadas para eliminar la(s) causa(s) de una no conformidad detectada u otra situación indeseable. 
                                                </li>
                                                <li>
                                                    <strong>ACCIÓN PREVENTIVA:</strong> Conjunto de acciones tomadas para eliminar la(s) causa(s) de una no conformidad potencial u
                                                </li>
                                                <li>
                                                    <strong>ALTA DIRECCIÓN:</strong> Persona o grupo de personas que dirigen y controlan al más alto nivel una entidad.  
                                                </li>
                                                <li>
                                                    <strong>CORRECCIÓN:</strong> Acción tomada para eliminar una n
                                                </li>
                                                <li>
                                                    <strong>MEJORA CONTINUA:</strong> Acción permanente realizada con el fin de aumentar la capacidad para cumplir los requisitos y optimizar el desempeño.  
                                                </li>
                                                <li>
                                                    <strong>NO CONFORMIDAD:</strong> Incumplimiento de un requisito.  
                                                </li>
                                                <li>
                                                    <strong>RIESGO:</strong> Toda posibilidad de ocurrencia de aquella situación que pueda entorpecer el desarrollo normal de las funciones de la entidad y le impidan el logro de sus objetivos 
                                                </li>
                                            </ul>
                                        </p>

                                    <h4 id="list-item-4">PROCEDIMIENTO</h4>
                                        <p>
                                            <ol>
                                                <li>
                                                    <strong>FUENTES</strong>
                                                    <br>
                                                    <p>
                                                        Para la ejecución de acciones correctivas o preventivas podemos tener diferentes fuentes como son: 
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            Auditorías del sistema de gestión de seguridad y salud en el trabajo.
                                                        </li>
                                                        <li>
                                                            Revisiones gerenciales del Sistema de Gestión.
                                                        </li>
                                                        <li>
                                                            Inspecciones de seguridad.
                                                        </li>
                                                        <li>
                                                            Desviaciones de las mediciones de los indicadores por proceso del Sistema de gestión.
                                                        </li>
                                                        <li>
                                                            Simulacros.
                                                        </li>
                                                        <li>
                                                            Mediciones ambientales.
                                                        </li>
                                                        <li>
                                                            Accidentes e incidentes de trabajo.
                                                        </li>
                                                        <li>
                                                            Enfermedades Laborales.
                                                        </li>
                                                        <li>
                                                            Reporte de condiciones de salud. 
                                                        </li>
                                                        <li>
                                                            Reporte de condiciones inseguras.
                                                        </li>
                                                        <li>
                                                            Requerimientos de las autoridades. 
                                                        </li>
                                                        <li>
                                                            Incumplimientos repetitivos de los planes de acción de inspecciones.
                                                        </li>
                                                    </ul>
                                                </li>

                                                <br>

                                                <li>
                                                    <strong>DETERMINAR LAS CAUSAS</strong>
                                                    <br>
                                                    <p>
                                                        Cuando se van a implementar acciones derivadas de las No Conformidades detectadas
                                                        en auditoría interna, investigación de accidentes, incidentes y enfermedades laborales,
                                                        o Incumplimientos repetitivos de los planes de acción de inspecciones, se deberá realizar
                                                        el análisis de causas. El responsable del proceso analiza las posibles causas que produjeron
                                                        el efecto no deseado, utilizando para ello técnicas estadísticas.
                                                        Las no conformidades menores u observaciones aceptadas no necesariamente
                                                        deben analizarse con las técnicas estadísticas. Sólo es necesario determinar la causa directamente. 
                                                    </p>
                                                </li>

                                                <br>

                                                <li>
                                                    <strong>TOMAR ACCIÓN</strong>
                                                    <br>
                                                    <p>
                                                        Se define un plan de acción orientado a corregir la situación detectada y
                                                        a eliminar las causas de las No conformidades reales o potenciales.
                                                        Este plan de acción debe incluir la actividad a ejecutar,
                                                        el responsable de ejecutar la acción y la fecha propuesta de cumplimiento. 
                                                    </p>
                                                </li>

                                                <br>

                                                <li>
                                                    <strong>REALIZAR SEGUIMIENTO Y CONTROL</strong>
                                                    <br>
                                                    <p>
                                                        El responsable del SG SST realiza el seguimiento al plan de acción definido.
                                                        Si la acción no fue eficaz el proceso comienza de nuevo, teniendo en cuenta
                                                        que la repetición de una no conformidad menor da como resultado
                                                        una no conformidad mayor. Si la acción fue eficaz se cierra la acción. 
                                                    </p>
                                                </li>
                                            </ol>
                                        </p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>


    </Layout>
</template>